import React from "react";
import {
  Dialog,
  Typography,
  DialogActions,
  DialogContent,
  CircularProgress,
} from "@mui/material";

import { Button } from "../Button";

interface IProps {
  title: string;
  opened: boolean;
  loading?: boolean;
  disabled?: boolean;
  labelSaveButton?: string;
  labelCloseButton?: string;
  maxWidth?: false | "xs" | "sm" | "md" | "lg" | "xl" | undefined;

  onClose?(): void;
  onClick?(): void;
}

export const Modal: React.FC<IProps> = ({
  title,
  opened,
  maxWidth,
  children,
  labelSaveButton,
  loading = false,
  disabled = false,
  labelCloseButton,

  onClose,
  onClick,
}) => {
  return (
    <Dialog open={opened} onClose={onClose} maxWidth={maxWidth} fullWidth>
      <Typography variant="h6" color="primary" sx={{ p: "8px 24px" }}>
        <strong>{title}</strong>
      </Typography>
      <DialogContent dividers>{children}</DialogContent>
      <DialogActions>
        {labelCloseButton && (
          <Button
            variant="outlined"
            onClick={onClose}
            disabled={loading}
            label={labelCloseButton}
          />
        )}
        {labelSaveButton && (
          <Button
            sx={{ ml: 1 }}
            onClick={onClick}
            label={labelSaveButton}
            disabled={loading || disabled}
          >
            {loading && (
              <CircularProgress size={24} sx={{ position: "absolute" }} />
            )}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
